import React from "react";


const ProcessModal = ()=>{

  return (
    <div className="cb-modal cb-spinner-modal" id='gloader' aria-hidden="true">
      <div className="cb-modal-overlay" tabIndex="-1">
        <div className="cb-modal-container" role="dialog" aria-modal="true" aria-labelledby="ID">
          <div className="cb-modal-content">
          <div role="status" aria-labelledby="loaderspin">
            <div className="cb-spinner cb-spinner-light" id="loaderspin" role="img" aria-label="Loading">
              <p className='cb-spinner-indicator' style={{color:'white'}}>Loading</p>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default ProcessModal;